import $ from 'jquery';
import notificationTemplate from 'bloko/blocks/notificationManager/notification.mustache';
import animationEventName from 'bloko/common/animationEventName';
import { NOTIFICATION_EXTRA_TYPES } from 'bloko/blocks/notificationManager/constants';

const cssClasses = {
    manager: 'bloko-notification-manager',
    inactive: 'bloko-notification_inactive',
};

const bindings = {
    manager: '.Bloko-Notification-Manager',
    close: '.Bloko-Notification-Close',
    content: '.Bloko-Notification-Content',
};

const defaults = {
    onClose() {},
};

let NOTIFICATION_AUTO_CLOSE_TIME_MS = 5000;

if (window.bloko && window.bloko.isTest) {
    NOTIFICATION_AUTO_CLOSE_TIME_MS = 10;
}

/**
 * @exports bloko/blocks/notificationManager/notificationManager
 */
export default (function() {
    let $notificationManager = $(bindings.manager);
    if ($notificationManager.length === 0) {
        $notificationManager = $('<div>', { class: cssClasses.manager }).appendTo('body');
    }

    /**
     * Компонент, который должен быть модулем. Возвращает объект c методом `close`, который закрывает нотификацию и
     * удаляет ее из DOM.
     *
     * @param {Object} params                       - Параметры нотификации
     * @param {String|Element} params.content       - Содержимое, которое будет отображено в теле нотификации
     * @param {function} params.onClose             - Функция, которая будет вызвана при закрытии нотификации
     * @param {String} [params.type]                - Тип нотификации, которую нужно показать: error - ошибка,
     *                                                ok - успех, delete - для удаления, message - действие или
     *                                                сообщение, question - вопрос, rating - оценка, по умолчанию info.
     * @param {Boolean} [params.autoClose=false]    - Флаг автоматического закрытия нотификации,
     *                                                по умолчанию через 5 секунд
     * @param {Number} [params.autoCloseDelay=5000] - Время в миллисекундах до автоматического закрытия нотификации
     *
     */
    function create(params) {
        params = $.extend({}, defaults, params);
        let timeout;
        const $notification = $(
            notificationTemplate.render({
                type: params.type,
                inverted: NOTIFICATION_EXTRA_TYPES.includes(params.type),
            })
        );

        $(bindings.content, $notification).html(params.content);

        function close() {
            $notification.addClass(cssClasses.inactive);
            if (animationEventName) {
                $notification.one(animationEventName, () => {
                    $notification.remove();
                    params.onClose();
                });
            } else {
                $notification.remove();
                params.onClose();
            }
        }

        $(bindings.close, $notification).on('click', () => {
            window.clearTimeout(timeout);
            close();
        });

        if (params.autoClose) {
            const closeDelay = params.autoCloseDelay || NOTIFICATION_AUTO_CLOSE_TIME_MS;
            timeout = window.setTimeout(close, closeDelay);
        }

        $notificationManager.prepend($notification);

        return {
            close,
        };
    }

    return {
        create,
    };
})();
